export function onRouteUpdate() {
  // Let Gatsby's Head API settle before measuring the destination title.
  window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
    window.DattleAnalytics?.pageView();
  }));
}
